export default __webpack_public_path__ + "static/media/fitness_mfp3.19e4b4dc.jpg";